<template>
  <div class="register">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
    <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' ></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>{{ titleName }}</h3></div>
    <div class="registerStepCon">
      <el-steps :active="2" align-center>
        <el-step title="1 填写企业信息"></el-step>
        <el-step title="2 完善个人信息"></el-step>
        <el-step title="3 提交审核"></el-step>
        <el-step title="4 完成注册"></el-step>
      </el-steps>
      <div class="examineCon" v-if="companyFlag">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerSuccess.png"
             alt="">
        <h5>提交成功</h5>
        <p class="registerRed">您的注册申请已提交至管理员审核，请耐心等候</p>
        <p>我们将于您提交申请后的一个工作日内完成审核并将通过邮件形式将审核结果发送至您的注册邮箱中</p>
      </div>
      <div class="examineCon" v-if="userFlag">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerSuccess.png"
             alt="">
        <h5>提交成功</h5>
        <p class="registerRed">您的注册申请已提交至管理员处</p>
        <p>若企业管理员未及时处理，您可通过邮件与其联系</p>
        <div class="list">
          <h6 @click="noMemUserList">企业管理员</h6>
          <p v-for="(menuUser,index) in memUserDtos" :key="index">
            <span>{{ menuUser.trueName }}</span><span>{{ menuUser.email }}</span></p>
        </div>
        <div class="help-message-container">
          <p class="title">无企业管理员或企业管理员已离职怎么办？</p>
          <p style="margin-bottom: 0px">
            请下载
            <a download="企业新增账号流程"
               href="http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/%E4%BC%81%E4%B8%9A%E6%96%B0%E5%A2%9E%E8%B4%A6%E5%8F%B7%E6%B5%81%E7%A8%8B.docx">情况说明模板</a>
            ，填写后并加盖公章，发送至一链网客服邮箱
            exonelink@wbpharma.com
          </p>
          <p style="color:#909399;">如有疑问可<a @click="goCustomerService">在线联系一链客服</a> 或 拨打客服电话
            0516-87796393
          </p>
        </div>
      </div>
      <el-button @click="goToHref('/')">返回首页</el-button>
    </div>
    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import registerTop from '@/components/registerTop'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
import {mapState} from 'vuex'
import {customSubmitAudit} from '@/assets/js/sensors'

export default {
  props: [],
  data () {
    return {
      userAgreementVisible: false,
      privacyPolicyVisible: false,
      centerDialogVisible: false,
      navigationColumnInfos: [],
      footerColumnInfos: [],
      webConfigInfo: {},
      checkList: [],
      navTitle: '注册',
      abroadShow: false,
      hitSearchUrl: '',
      enterpriseResourceBaseUrl: '',
      yellowPageColumn: {},
      productAndSolutionColumn: {},
      regeisterSuccessInfo: {},
      memUserDtos: [],
      memUserDto: {},
      regeisterInfo: {},
      selectOrgIdentity: {},
      titleName: '',
      companyFlag: false,
      userFlag: false,
      email: '',
      companyId: '',
      companyName: '',
      orgIdentity: '',
      regAddrType: '',
      trueName: '',
      password: '',
      rememeberPassword: false,
      loginFlag: false,
      checkFlag: false,
      userInfo: {},
      companyInfo: {},
      messageNumber: '',
      regeisterType: '',
      checkCardInfo: {},
      userExamineStatus: '',
      redirectURL: '',
      accountInfo: {},
      createUserId: '',
      uCenterOrgInformation: {},
      companyUserInfo: {}

    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-registerTop': registerTop,
    'v-footer': footer,
    'v-backToTop': backToTop
  },
  computed: mapState([
    'KP'
  ]),
  mounted () {
    var mvp = document.getElementById('testViewport')
    if (window.location.pathname === '/registerExamine') {
      mvp && mvp.setAttribute('content', 'width=device-width')
    }
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    try {
      setTimeout(() => {
        customSubmitAudit({
          org_id: this.companyId,
          org_name: this.companyName
        })
      }, 2000)
    } catch (e) {
      console.log(e)
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.endunloadHandler(e))
  },
  created () {
    let query = this.$route.query
    this.email = query.email
    this.companyId = query.companyId
    this.companyName = query.companyName
    this.orgIdentity = query.orgIdentity
    this.regAddrType = query.regAddrType
    this.trueName = query.trueName
    this.userId = query.userId
    this.createUserId = query.createUserId
    this.password = query.text

    if (typeof (this.orgIdentity) === 'undefined') {
      this.regeisterType = this.getToken('regeisterType')
      this.regeisterInfo = JSON.parse(this.getDAesString(this.getToken('regeisterInfo'), this.KP.key, this.KP.iv))
      this.selectOrgIdentity = this.regeisterInfo.orgIdentity

      if (this.regeisterType === 'company') {
        this.companyFlag = true
      } else {
        this.companyFlag = false
      }
      if (this.regeisterType === 'user') {
        this.userFlag = true
      } else {
        this.userFlag = false
      }
      this.regeisterSuccessInfo = JSON.parse(this.getDAesString(this.getToken('regeisterSuccessInfo'), this.KP.key, this.KP.iv))
    } else {
      this.selectOrgIdentity = this.orgIdentity
      if (this.createUserId === this.userId) {
        this.companyFlag = true
        this.userFlag = false
        this.regeisterType = 'company'
      } else {
        this.userFlag = true
        this.companyFlag = false
        this.regeisterType = 'user'
      }
      this.regeisterInfo.companyName = this.companyName
      this.regeisterInfo.orgIdentity = this.orgIdentity
      this.regeisterInfo.regAddrType = this.regAddrType
      this.regeisterInfo.companyId = this.companyId
      this.regeisterSuccessInfo.companyId = this.companyId
      this.regeisterSuccessInfo.trueName = this.trueName
      this.regeisterSuccessInfo.email = this.email
    }

    if (this.selectOrgIdentity === '20') {
      this.titleName = '采购商注册'
    }
    if (this.selectOrgIdentity === '10') {
      this.titleName = '供应商注册'
    }

    this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainRegeisterCommonInfo', {
      companyId: this.regeisterSuccessInfo.companyId,
      trueName: this.regeisterSuccessInfo.trueName,
      email: this.regeisterSuccessInfo.email
    }).then((res) => {
      this.data = res.data
      this.userExamineStatus = this.data.userExamineStatus
      this.checkCardInfo = this.data.checkCardInfo
      this.createUserId = this.data.createUserId
      this.uCenterOrgInformation = this.data.uCenterOrgInformation
      this.companyUserInfo = this.data.companyUserInfo
      this.regeisterType = this.data.regeisterType
      if (this.userExamineStatus === '20' || this.userExamineStatus === '30') {
        if (this.userExamineStatus === '20') {
          this.setToken('isLogin', 100)
          this.setToken('examineStatus', 200)
          this.$router.push({
            path: 'registerFailed',
            query: {
              userId: this.companyUserInfo.userId,
              email: this.regeisterSuccessInfo.email,
              companyId: this.uCenterOrgInformation.id,
              companyName: this.companyUserInfo.orgName,
              orgIdentity: this.uCenterOrgInformation.orgIdentity,
              regAddrType: this.uCenterOrgInformation.regAddrType,
              regeisterType: this.regeisterType,
              exmaineMessage: this.checkCardInfo.checkRemark,
              createUserId: this.createUserId
            }
          })
        }
        if (this.userExamineStatus === '30') {
          this.setToken('isLogin', 100)
          this.setToken('examineStatus', '')
          this.$router.push({path: '/'})
        }
      } else {
        this.webConfigInfo = this.data.webConfigInfoDto
        this.footerColumnInfos = this.data.footerColumnInfos
        this.navigationColumnInfos = this.data.navigationColumnInfos
        this.yellowPageColumn = this.data.yellowPageColumn
        this.productAndSolutionColumn = this.data.productAndSolutionColumn
        this.hitSearchUrl = this.data.hitSearchUrl
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl
        this.memUserDtos = this.data.memUserDtos
        if (this.memUserDtos.length > 0) {
          this.memUserDto = this.memUserDtos[0]
        }
      }
    }).catch((err) => {
      console.log(err)
    })
  },

  methods: {
    goToHref (val) {
      this.$router.push({path: val})
    },
    // 在线客服
    goCustomerService () {
      window.open('https://onelinkplus.udesk.cn/im_client/?web_plugin_id=52506&cur_title=%E4%B8%80%E9%93%BE%E7%BD%91&src_url=&cur_url=http%253A%252F%252Fex.onelinkplus.com%252Fportal%252Findex&pre_url=http%3A%2F%2Fex.onelinkplus.com%2Fportal%2Findex')
    },
    noMemUserList () {
      if (this.memUserDtos.length <= 0) {
        this.$message('无企业管理员')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>

.register {
  .help-message-container {
    text-align: left;
    margin-left: 240px;
    color: #666;
    padding-top: 30px;

    .title {
      color: #000;
    }

    a {
      color: #3f88e0;
      cursor: pointer;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/registerExamine/index.vue